import RootStore from './RootStore';
// import videoApi from '../actions/video';
import { IResult } from '../global.d';
import { observable, action, computed } from 'mobx';

import documentApi from '../actions/document';

export interface IDocument {
  id: number;
  type: string;
  gallery_id: string | number;
  doc_name: string;
  doc_status: number;
  doc_origin: string;
  doc_result: string;
  medium_id: string | number;
}

export interface IDocumentMap {
  [key: string]: IDocument;
}

export interface IPPTClip {
  doc_id: number;
  id: number;
  current: number;
  second: number;
}

export default class IMStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable list = {} as IDocumentMap;

  oneByMedium = (video_id: number | string, force?: boolean) => {
    return documentApi.oneByMedium(video_id, force).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          // let map = {} as IMediumMap;
          // data.forEach((it: IMedium) => {
          //   map[String(it.id)] = it;
          // });
          //
          if (data && data.id) {
            this.list = {
              ...this.list,
              [String(data.id)]: data
            };
          }

          return res.data;
        }

        return null;
      })
    );
  };

  one = (id: string | number, force?: boolean) => {
    return documentApi.one(id, force).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          // let map = {} as IMediumMap;
          // data.forEach((it: IMedium) => {
          //   map[String(it.id)] = it;
          // });
          //
          if (data && data.id) {
            this.list = {
              ...this.list,
              [String(data.id)]: data
            };
          }

          return res.data;
        }

        return null;
      })
    );
  };

  getVideo = (id: number) => {
    return this.list[String(id)];
  };

  getClipList = (doc_id: number, begin_at: number, end_at: number) => {
    return documentApi
      .getClipList(doc_id, begin_at, end_at)
      .then((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          if (data && data.length) {
            data.sort((a: any, b: any) => {
              return Number(a.second || 0) > Number(b.second || 0) ? 1 : -1;
            });

            // 加入一个极大值在最后，就免得循环的时候去判断了，否则不会跳转到最后一条数据
            data.push({
              current: 0,
              second: 86400 * 30,
              id: -1,
              doc_id: doc_id
            } as IPPTClip);

            return data as IPPTClip[];
          }
        }

        return [] as IPPTClip[];
      });
  };
}
